import { postImageDirect } from './documentDatas';
import { normalizeBankMedia } from '../shared/media/mediaBank';
import {
  MEDIA_CONTEXTS,
  defaultResolutionFor,
  mediaSelection,
} from '../shared/media/mediaResolution';

/**
 * Envoi d'un média depuis l'éditeur classique.
 *
 * Le fichier part directement au stockage (`signed_id`), puis l'endpoint image
 * du document range le média dans son dossier automatique. Rend la sélection
 * prête à poser sur une box : l'URL du palier retenu, l'id du média et le
 * palier lui-même — de quoi rouvrir le sélecteur de résolution plus tard.
 *
 * Un back qui ne renverrait encore que `{ url }` reste exploitable : le média
 * n'a alors aucun palier et la sélection porte l'original, comme avant.
 */
export async function uploadDocumentMedia({
  documentId,
  documentType,
  file,
  onProgress,
  context = MEDIA_CONTEXTS.pdf,
}) {
  const payload = await postImageDirect(documentId, documentType, { file, onProgress });
  const media = normalizeBankMedia(payload);
  if (!media) throw new Error('Réponse upload invalide : URL du média absente.');

  return { media, selection: mediaSelection(media, defaultResolutionFor(media, context)) };
}
